/* OTP — Perguntas frequentes.
   <details> keeps it working with JS off; this only adds the height animation
   and the one-open-at-a-time behaviour. */

class OtpFaq extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.otp-faq__item'));
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.items.forEach((item) => {
      const summary = item.querySelector('summary');
      if (!summary) return;
      summary.addEventListener('click', (event) => {
        event.preventDefault();
        item.open ? this.close(item) : this.open(item);
      });
    });

    // Theme Editor: reveal the row whose block was just selected.
    document.addEventListener('shopify:block:select', (event) => {
      const item = event.target.closest?.('.otp-faq__item');
      if (item && this.contains(item) && !item.open) this.open(item);
    });
  }

  get exclusive() {
    return this.dataset.exclusive !== 'false';
  }

  panelOf(item) {
    return item.querySelector('.otp-faq__panel');
  }

  open(item) {
    if (this.exclusive) {
      this.items.forEach((other) => {
        if (other !== item && other.open) this.close(other);
      });
    }

    const panel = this.panelOf(item);
    item.open = true;
    if (!panel || this.reduced) return;

    panel.style.height = '0px';
    panel.getBoundingClientRect();
    panel.style.height = panel.scrollHeight + 'px';
    this.after(panel, () => {
      panel.style.height = 'auto';
    });
  }

  close(item) {
    const panel = this.panelOf(item);
    if (!panel || this.reduced) {
      item.open = false;
      return;
    }

    panel.style.height = panel.scrollHeight + 'px';
    panel.getBoundingClientRect();
    panel.style.height = '0px';
    this.after(panel, () => {
      item.open = false;
      panel.style.height = '';
    });
  }

  /* transitionend can go missing (tab hidden, height unchanged) — always
     settle the row with a timer so it never gets stuck mid-animation. */
  after(panel, done) {
    let settled = false;
    const finish = () => {
      if (settled) return;
      settled = true;
      panel.removeEventListener('transitionend', onEnd);
      done();
    };
    const onEnd = (event) => {
      if (event.target === panel && event.propertyName === 'height') finish();
    };
    panel.addEventListener('transitionend', onEnd);
    setTimeout(finish, 480);
  }
}

if (!customElements.get('otp-faq')) {
  customElements.define('otp-faq', OtpFaq);
}
